import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-ZFJLLTR46P';
export const CONSENT_KEY = 'analytics-consent';
export const ANALYTICS_CONSENT_UPDATED_EVENT = 'analytics-consent-updated';
export const COOKIE_SETTINGS_OPEN_EVENT = 'cookie-settings-open';

let initialized = false;

const dispatchWindowEvent = (eventName, detail = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const getAnalyticsConsent = () => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(CONSENT_KEY);
};

export const hasAnalyticsConsent = () => getAnalyticsConsent() === 'granted';

export const getAnalyticsConsentStatusLabel = (decision = getAnalyticsConsent()) => {
  if (decision === 'granted') return 'On';
  if (decision === 'denied') return 'Off';
  return 'Not set';
};

export const setAnalyticsConsent = decision => {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem(CONSENT_KEY, decision);
  dispatchWindowEvent(ANALYTICS_CONSENT_UPDATED_EVENT, { decision });
};

export const clearAnalyticsConsent = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.removeItem(CONSENT_KEY);
  dispatchWindowEvent(ANALYTICS_CONSENT_UPDATED_EVENT, { decision: null });
};

export const openCookieSettings = () => {
  dispatchWindowEvent(COOKIE_SETTINGS_OPEN_EVENT, { open: true });
};

export const initializeAnalyticsIfConsented = () => {
  if (!hasAnalyticsConsent()) return false;

  if (!initialized) {
    ReactGA.initialize(TRACKING_ID);
    initialized = true;
  }

  return true;
};

export const sendPageViewIfConsented = page => {
  if (!initializeAnalyticsIfConsented()) return false;

  ReactGA.send({
    hitType: 'pageview',
    page,
  });

  return true;
};

export const trackEventIfConsented = (eventName, params = {}) => {
  if (!eventName || !initializeAnalyticsIfConsented()) {
    return false;
  }

  ReactGA.event(eventName, params);

  return true;
};
